import {
  DyteAvatar,
  DyteNameTag,
  DyteParticipantTile,
} from "@dytesdk/react-ui-kit";
import { useDyteMeeting } from "@dytesdk/react-web-core";
import { DyteParticipant } from "@dytesdk/web-core";

interface MenteeVideoTileProps {
  remoteParticipant: DyteParticipant | null;
}

export default function MenteeVideoTile({
  remoteParticipant,
}: MenteeVideoTileProps) {
  const { meeting } = useDyteMeeting();

  return (
    <div className="flex size-full items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800">
      {remoteParticipant ? (
        <div className="relative flex size-full items-center justify-center">
          <DyteParticipantTile
            participant={remoteParticipant}
            meeting={meeting}
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "transparent",
              borderRadius: "16px",
              objectFit: "cover",
            }}
          >
            <DyteNameTag participant={remoteParticipant} meeting={meeting} />
            <DyteAvatar size="sm" participant={remoteParticipant} />
          </DyteParticipantTile>
        </div>
      ) : (
        <div className="flex size-full flex-col items-center justify-center">
          <span className="mb-2 text-lg font-semibold text-white">
            Waiting for mentee to join…
          </span>
          <span className="text-sm text-white/70">
            Your mentor's video will appear here once they join the call.
          </span>
        </div>
      )}
    </div>
  );
}
